import React, { useEffect, useState } from "react";
import {
  SlSelect,
  SlOption,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import API from "../../services/api";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { format, subMonths } from "date-fns";
import { getBrandOptions, toLakhs } from "../../utils/constants";
import * as XLSX from "xlsx";
import ScrollContainer from "react-indiana-drag-scroll";

function Conversion() {
  const [newsPapers, setNewsPapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [loader, setLoader] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const year = new Date().getFullYear() % 100;
  const [selectedType, setSelectedType] = useState("all");
  const [data, setData] = useState([{}]);
  let currDate = new Date().setDate(1);
  let prevDate = subMonths(currDate, 11);
  let monthArray = [];
  for (let i = 0; i < 12; i++) {
    let start = format(prevDate, "MMMyy");
    let end = format(currDate, "MMMyy");
    currDate = subMonths(currDate, 1);
    prevDate = subMonths(prevDate, 1);
    monthArray.push(`${start}-${end}`);
  }
  monthArray.reverse();
  const fetchData = async () => {
    try {
      setLoader(true);
      let res = await API({
        url: "/conversion/get",
        method: "POST",
        responseType: "json",
        data: {
          newsPaper: selectedNewspaper,
          type: selectedType,
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if(res.data.userType !== -1){
          setSelectedType(`${res.data?.userType}`)
        }
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };
  const fetchNewsPapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewsPapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getdownloadData = () => {
    setDownloadLoader(true);
    try {
      const wb = XLSX.utils.book_new();

    // Data for the sheet
    const sheetData = [
      ["Revenues in Lakhs", ...monthArray, `Jan${year}-Dec${year}`], // Header row
      [
        "Total Deployed Accounts",
        ...monthArray.map((item) => data["deployyedAccounts"]?.[item]?.unique_brands || ""),
        data["plannedData"]?.total_counts || "",
      ],
      ["W2N", ...monthArray.map((item) =>  ""), ""],
      [
        "Accounts Advertised",
        ...monthArray.map((item) => data["way2newsData"]?.[item]?.unique_brands || ""),
        data["plannedData"]?.total_counts || "",
      ],
      [
        "No. of Insertions",
        ...monthArray.map((item) => data["way2newsData"]?.[item]?.total_count || ""),
        data["plannedData"]?.total_insertions || "",
      ],
      [
        "Revenues",
        ...monthArray.map((item) =>
          toLakhs(data["way2newsData"]?.[item]?.total_amount || 0)
        ),
        data["plannedData"]?.total_revenue || "",
      ],
      [selectedNewspaper, ...monthArray.map((item) => ""), ""],
      [
        "Accounts Advertised",
        ...monthArray.map((item) => data["newsPaperData"]?.[item]?.unique_brands || ""),
        "",
      ],
      [
        "No. of Insertions",
        ...monthArray.map((item) => data["newsPaperData"]?.[item]?.total_count || 0),
        "",
      ],
      [
        "Revenues",
        ...monthArray.map((item) =>
          toLakhs(data["newsPaperData"]?.[item]?.total_amount || 0)
        ),
        "",
      ],
    ];

    // Add the data to a worksheet
    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    let merges = [];
    merges.push({ s: { r: 2, c: 0 }, e: { r: 2, c: 13 } });
    merges.push({ s: { r: 6, c: 0 }, e: { r: 6, c: 13 } });
    ws["!merges"] = merges;
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Table Data");

    // Export to Excel
    XLSX.writeFile(wb, `conversion_progress${year}.xlsx`);
    } catch (error) {
      console.error(error);
    } finally {
      setDownloadLoader(false);
    }
  };

  useEffect(() => {
    fetchNewsPapers();
  }, []);

  useEffect(() => {
    fetchData();
  }, [selectedNewspaper, selectedType]);

  return (
    <>
      <h5>12 Months Rolling Average</h5>
      <div className="d-flex gap-3 justify-end my-2 items-center">
      <SlSelect size="small" value={selectedType} label="Team" onSlChange={(e) => {setSelectedType(e.target.value)}}>
      {data?.userType === -1 ? <SlOption value='all'>All</SlOption> : null}
          {getBrandOptions(data?.userType, localStorage.getItem('email'))?.map((type) => (
            <SlOption key={type.value} value={type.value}>{type.label}</SlOption>
          ))}
        </SlSelect>
        <SlSelect
          placeholder="NewsPaper"
          value={selectedNewspaper}
          onSlChange={(e) => setSelectedNewspaper(e.target.value)}
        >
          {newsPapers.map((item) => (
            <SlOption key={item.name} value={item.name}>
              {item.name}
            </SlOption>
          ))}
        </SlSelect>
        {downloadLoader ? (
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          <div
            className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
            onClick={getdownloadData}
          >
            <sl-tooltip content="Download" placement="top">
              <SlIcon library="lucide" name="download" />
            </sl-tooltip>
          </div>
        )}
      </div>
      <ScrollContainer>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Revenues in Lakhs</th>
            {monthArray.map((item) => (
              <th>{item}</th>
            ))}
            <th>
              Jan{year}-Dec{year}
            </th>
          </tr>
        </thead>
        {!loader && Object.keys(data)?.length > 0 ? (
          <tbody>
            <tr>
              <th>TOtal Deployed Accounts</th>
              {monthArray.map((item) => (
                <td>{data["deployyedAccounts"]?.[item]?.unique_brands}</td>
              ))}
              <td>{data["plannedData"]?.total_counts}</td>
            </tr>
            <tr>
              <th colSpan={14}>W2N</th>
            </tr>
            <tr>
              <td>Accounts Advertised</td>
              {monthArray.map((item) => (
                <td>{data["way2newsData"]?.[item]?.unique_brands}</td>
              ))}
              <td>
                <td>{data["plannedData"]?.total_counts}</td>
              </td>
            </tr>
            <tr>
              <td>No. of Insertions</td>
              {monthArray.map((item) => (
                <td>{data["way2newsData"]?.[item]?.total_count}</td>
              ))}
              <td>{data["plannedData"]?.total_insertions}</td>
            </tr>
            <tr>
              <td>
                <td>Revenues</td>
              </td>
              {monthArray.map((item) => (
                <td>
                  {toLakhs(data["way2newsData"]?.[item]?.total_amount || 0)}
                </td>
              ))}

              <td>{toLakhs(data["plannedData"]?.total_revenue)}</td>
            </tr>
            <tr>
              <th colSpan={14}>{selectedNewspaper}</th>
            </tr>
            <tr>
              <td>Accounts Advertised</td>
              {monthArray.map((item) => (
                <td>{data["newsPaperData"]?.[item]?.unique_brands}</td>
              ))}
              <td></td>
            </tr>
            <tr>
              <td>No. of Insertions</td>
              {monthArray.map((item) => (
                <td>{data["newsPaperData"]?.[item]?.total_count || 0}</td>
              ))}
              <td></td>
            </tr>
            <tr>
              <td>
                <td>Revenues</td>
              </td>
              {monthArray.map((item) => (
                <td>
                  {toLakhs(data["newsPaperData"]?.[item]?.total_amount || 0)}
                </td>
              ))}
              <td></td>
            </tr>
          </tbody>
        ) : loader ? (
          <TableLoader colspan={14} />
        ) : (
          <NoDataFound colspan={14} />
        )}
      </table>
      </ScrollContainer>
    </>
  );
}

export default Conversion;
